import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {StationChargeCodeStatusApiModel, UnlockStationChargeCodeRequest} from 'spotcharge-types';
import {BaseOccpHttpService} from './base-occp-http.service';

@Injectable({
  providedIn: 'root',
})
export class StationChargeCodeHttpService {
  private occpHttp = inject(BaseOccpHttpService);

  status(stationId: string): Observable<StationChargeCodeStatusApiModel> {
    return this.occpHttp.get<StationChargeCodeStatusApiModel>(
      `api/consumer/me/station-charge-codes/${encodeURIComponent(stationId)}`,
    );
  }

  unlock(stationId: string, code: string): Observable<StationChargeCodeStatusApiModel> {
    const body: UnlockStationChargeCodeRequest = {code};
    return this.occpHttp.post<StationChargeCodeStatusApiModel>(
      `api/consumer/me/station-charge-codes/${encodeURIComponent(stationId)}/unlock`,
      body,
    );
  }
}
